














// @ is an alias to /src
import { Component } from "vue-property-decorator";
import axios from "axios";
import { SVG, Svg, Rect, Text, G, List, Element } from "@svgdotjs/svg.js";
import HacoBase from "../HacoBase";

interface ScenarioMargin {
  id: number;
  scenarioId: number;
  deliveryDateTypeId: number;
  fixedCost: number;
  rate: number;
}
interface ItemName {
  [key: string]: any;
}
interface Scenario extends ItemName {
  active: number;
  displayMethodTypeId: number;
  groupCoaters: number[];
  groupCustoms: number[];
  groupDieCuts: number[];
  groupGlues: number[];
  groupOthers: number[];
  groupMargins: number[];
  id: number;
  impositionLimit: number | null;
  itemPaperSizeId: number | number[];
  itemPrinterId: number | number[];
  scenarioName: string;
}

interface MapData {
  itemCoaters: ItemName;
  itemCustoms: ItemName;
  itemDieCuts: ItemName;
  itemGlues: ItemName;
  itemPaperSizes: ItemName;
  itemPrinters: ItemName;
  scenarios: Scenario[];
}
interface ScenarioKeys {
  propName: string;
  className: string;
  numOfItems: number;
}

@Component
export default class RouteMap extends HacoBase {
  mapData: any;
  $debugServer!: string;
  $certification!: boolean;
  currentPage: string | undefined = "";
  draw!: Svg;
  viewBoxVal = 1;
  fieldW = 0;
  fieldH = 0;
  boxTop = 80;
  scenarioNames!: G;
  scenarioKeys: ScenarioKeys[] = [
    {
      propName: "itemPaperSizeId",
      className: "itemPaperSizes",
      numOfItems: 0
    },
    {
      propName: "itemPrinterId",
      className: "itemPrinters",
      numOfItems: 0
    },
    {
      propName: "groupCoaters",
      className: "itemCoaters",
      numOfItems: 0
    },
    {
      propName: "groupDieCuts",
      className: "itemDieCuts",
      numOfItems: 0
    },
    {
      propName: "groupGlues",
      className: "itemGlues",
      numOfItems: 0
    },
    {
      // 描画用ダミー
      propName: "groupOptions",
      className: "itemOptions",
      numOfItems: 0
    },
    {
      // 描画用ダミー
      propName: "groupOthers",
      className: "itemOthers",
      numOfItems: 0
    },
    {
      // 描画用ダミー
      propName: "groupCustoms",
      className: "itemCustoms",
      numOfItems: 0
    },
    {
      // 描画用ダミー
      propName: "groupMargins",
      className: "itemMargins",
      numOfItems: 0
    }
  ];
  mounted(): void {
    const url = this.$debugServer + "/api/v1_inner/route_map";
    const params: object = this.setAxiosParams(url, "get");
    //データ取ってくる
    axios(params)
      .then((response: any): void => {
        this.mapData = response.data;
        this.drawMap();
      })
      .catch((error: any): void => {
        console.log("[error]", error.response);
        this.toLoginPage(error);
      });
  }

  drawMap(): void {
    if (this.draw) {
      // 二重描画防止
      return;
    }
    const mapData: any = this.mapData;
    // fieldHを求める為に最大Itemを数える
    let numOfMaxItem = mapData.scenarios.length;
    let item: ScenarioKeys;
    for (item of this.scenarioKeys) {
      if (mapData[item.className]) {
        Object.keys(mapData[item.className]).forEach(
          (key: string, j: number): void => {
            numOfMaxItem = Math.max(numOfMaxItem, j);
            item.numOfItems = j + 1;
          }
        );
      }
    }

    let i = 0;
    const nameWidth = 240;
    const nameHeight = 40;
    const nameVmargin = 60;
    const hMargin = 120;
    this.fieldW = 3500;
    this.fieldH = (nameHeight + nameVmargin) * (numOfMaxItem + 2) + 40;
    this.draw = SVG()
      .addTo("#svgField")
      .size(this.fieldW, this.fieldH)
      .click(this.deFocus);
    const plateColor = "#d8e2ed";
    const textColor = "#1e2944";
    const colors: string[] = [
      "#ffc426",
      "#c4ff26",
      "#26ff6c",
      "#26e4ff",
      "#816fff",
      "#c959ff",
      "#ff26be",
      "#ff4d26"
    ];

    const categoryLabels: G = this.draw.group().attr({ id: "categoryLabels" });
    const categoryLabel: string[] = [
      this.$t("message.globalNav.scenario") as string,
      this.$t("message.globalNav.paperSize") as string,
      this.$t("message.globalNav.printer") as string,
      this.$t("message.globalNav.coater") as string,
      this.$t("message.globalNav.dieCut") as string,
      this.$t("message.globalNav.glue") as string,
      this.$t("message.globalNav.option") as string,
      this.$t("message.globalNav.other") as string,
      this.$t("message.globalNav.custom") as string,
      this.$t("message.scenarioEdit.margin") as string
    ];

    for (const item of categoryLabel) {
      new Rect()
        .size(nameWidth, 30)
        .attr({
          x: i === 0 ? 20 : nameWidth * i + hMargin * i,
          fill: "#24D5B1"
        })
        .radius(2)
        .addTo(categoryLabels);
      const labelX = nameWidth * i + hMargin * i;
      const label: Text = categoryLabels
        .text(item)
        .font({
          size: 12
        })
        .fill(textColor)
        .attr({
          y: 5
        });
      const bbox: any = label.bbox();
      if (i === 0) {
        label.move(20 + ((nameWidth - bbox.width) >> 1), bbox.y);
      } else {
        label.move(labelX + ((nameWidth - bbox.width) >> 1), bbox.y);
      }
      i += 1 | 0;
    }
    categoryLabels.addClass("categoryLabels").move(20, 20);

    interface Categories {
      [key: string]: G;
    }
    const categories: Categories = {
      itemPaperSizes: this.draw.group(),
      itemPrinters: this.draw.group(),
      itemCoaters: this.draw.group(),
      itemDieCuts: this.draw.group(),
      itemGlues: this.draw.group(),
      itemOptions: this.draw.group(),
      itemOthers: this.draw.group(),
      itemCustoms: this.draw.group(),
      itemMargins: this.draw.group()
    };

    let j = 1;
    // アイテムボックス描画
    Object.keys(categories).forEach((key: string): void => {
      i = 0;
      if (mapData[key] === undefined) {
        mapData[key] = {};
      }
      if (key === "itemOptions") {
        mapData[key] = ["Option"];
      } else if (key === "itemOthers") {
        mapData[key] = ["Other"];
      } else if (key === "itemMargins") {
        mapData[key] = ["Margin"];
      } else {
        mapData[key]["0"] = this.$t("message.routeMap.notAssigned");
      }

      categories[key].attr({ id: key });
      Object.keys(mapData[key]).forEach((k: string): void => {
        const nameY = nameHeight * i + nameVmargin * i;
        let labelColor: string;
        let rectAttr: object;
        if (mapData[key][k] === this.$t("message.routeMap.notAssigned")) {
          labelColor = plateColor;
          rectAttr = {
            y: nameY,
            fill: "rgba(216, 226, 237, 0.125)",
            stroke: plateColor,
            "stroke-dasharray": "1 1",
            "stroke-width": 1
          };
        } else {
          labelColor = textColor;
          rectAttr = {
            y: nameY,
            fill: plateColor
          };
        }

        const rect: Rect = new Rect()
          .size(nameWidth, nameHeight)
          .attr(rectAttr)
          .radius(2)
          .addTo(categories[key]);
        const label: Text = categories[key]
          .text(mapData[key][k])
          .font({
            size: 12
          })
          .fill(labelColor)
          .attr({
            x: 10,
            y: nameY + 10
          })
          .addClass("textLabel");
        const hitRect: Rect = rect
          .clone()
          .attr({
            id: key + "_" + k,
            fill: "#000",
            opacity: 0
          })
          .addTo(categories[key])
          .addClass("itemBlock")
          .addClass(key);
        if (mapData[key][k] === this.$t("message.routeMap.notAssigned")) {
          hitRect.addClass("emptyBlock");
        } else {
          hitRect.click(this.moveToEditScreen(i, key));
        }
        const bbox: any = label.bbox();
        label.move((nameWidth - bbox.width) >> 1, bbox.y);

        i += 1 | 0;
      });

      categories[key].move((nameWidth + hMargin) * j, this.boxTop);
      j += 1 | 0;
    });

    // ScenarioName
    this.scenarioNames = this.draw.group().addClass("scenarioNames");
    i = 0;
    const scenarios: Scenario[] = this.mapData.scenarios;
    const colorsLength = colors.length;

    let oneScenario: Scenario;
    let toPos: any;
    for (oneScenario of scenarios) {
      toPos = [];
      // 表示用にデータ加工
      let numToArray: number = oneScenario.itemPaperSizeId as number;
      oneScenario.itemPaperSizeId = [numToArray];
      numToArray = oneScenario.itemPrinterId as number;
      oneScenario.itemPrinterId = [numToArray];
      oneScenario.groupOptions = [0];
      oneScenario.groupOthers = [0];
      oneScenario.groupMargins = [0];

      const nameY = nameHeight * i + nameVmargin * i;
      const rect: Rect = new Rect()
        .size(nameWidth, nameHeight)
        .attr({
          y: nameY,
          fill: "#5F2BE8"
        })
        .radius(2)
        .addTo(this.scenarioNames);
      const label: Text = this.scenarioNames
        .text(oneScenario.scenarioName)
        .font({
          size: 12
        })
        .fill("#fff")
        .attr({
          y: nameY + 10
        });
      rect
        .clone()
        .attr({
          opacity: 0,
          fill: "#000"
        })
        .click(this.focusScenario(i))
        .addTo(this.scenarioNames);
      rect.addClass("namePlate");

      const bbox: any = label.bbox();
      label.move((nameWidth - bbox.width) >> 1, bbox.y);
      let j = 1;
      let l = 0;
      let toX = 0;
      let toY = 0;
      let startX: number;
      let startY = 0;
      let category: ScenarioKeys;
      for (category of this.scenarioKeys) {
        toPos[l] = [];
        let target: Rect;
        let targetBox: any;
        const oneColor = i % colorsLength;
        startX =
          category.propName === "itemPaperSizeId"
            ? nameWidth * j + 20
            : toX + nameWidth;
        if (oneScenario[category.propName].length === 0) {
          oneScenario[category.propName][0] = 0;
        }

        if (category.propName === "itemPaperSizeId") {
          startY = nameY + (nameHeight >> 1) + this.boxTop;
          const categoryItem: any = oneScenario.itemPaperSizeId;
          target = this.draw.find(
            "#" + category.className + "_" + categoryItem
          )[0] as Rect;
          if (target === undefined) {
            target = this.draw.find("." + category.className)[0] as Rect;
          }
          targetBox = target.bbox();
          toX = targetBox.x;
          toY = targetBox.y;
          toPos[l].push(toY);
          let rnd = (Math.random() * nameHeight) << 0;
          if (rnd < 10) {
            rnd = 10;
          } else if (rnd > nameHeight - 10) {
            rnd = nameHeight - 10;
          }
          this.drawToNext(
            i,
            l,
            startX,
            startY,
            toX,
            toY + rnd,
            colors[oneColor],
            category.className
          );
        } else {
          for (const categoryItem of oneScenario[category.propName]) {
            let m = 0;
            const onePos: number[] = toPos[l - 1];
            const len = onePos.length;
            let rnd = (Math.random() * nameHeight) << 0;
            if (rnd < 10) {
              rnd = 10;
            } else if (rnd > nameHeight - 10) {
              rnd = nameHeight - 10;
            }
            /** 一個前のアイテムの個数分線を引く */
            for (m = 0; m < len; m++) {
              startY = onePos[m];
              target = this.draw.find(
                "#" + category.className + "_" + categoryItem
              )[0] as Rect;
              if (target === undefined) {
                target = this.draw.find("." + category.className)[0] as Rect;
              }

              targetBox = target.bbox();
              toX = targetBox.x;
              toY = targetBox.y;
              const lastPos = toPos[l][toPos[l].length - 1];
              if (lastPos !== toY) {
                toPos[l].push(toY);
              }
              this.drawToNext(
                i,
                l,
                startX,
                startY + rnd,
                toX,
                toY + rnd,
                colors[oneColor],
                category.className
              );
            }
          }
        }

        j += 1 | 0;
        l += 1 | 0;
      }
      i += 1 | 0;
    }
    this.scenarioNames.move(20, this.boxTop).front();
    window.addEventListener("scroll", this.moveScenarioNames);
  }

  drawToNext(
    i: number,
    l: number,
    startX: number,
    startY: number,
    toX: number,
    toY: number,
    oneColor: string,
    category: string
  ): void {
    this.draw
      .line(startX, startY, toX, toY)
      .stroke({
        width: 1,
        color: oneColor
      })
      .attr({
        id: category + "_" + l
      })
      .addClass("arrow")
      .addClass("arrow_" + i);
  }

  moveToEditScreen(scenarioId: number, category: string): Function {
    return (): void => {
      const pageNameList: ItemName = {
        itemPaperSizes: "PaperSize",
        itemPrinters: "PrinterEdit",
        itemCoaters: "CoaterEdit",
        itemDieCuts: "DiecutEdit",
        itemGlues: "GlueEdit",
        itemOptions: "Option",
        itemOthers: "Other",
        itemCustoms: "CustomEdit",
        itemMargins: "itemMargins"
      };
      if (category === "itemMargins") {
        return;
      }
      window.scrollTo(0, 0);
      this.$router.push({
        name: pageNameList[category],
        params: { id: scenarioId.toString() }
      });
    };
  }

  focusScenario(num: number): Function {
    return (e: any): void => {
      e.stopPropagation();
      const namePlates: any = this.scenarioNames.find(".namePlate");
      namePlates.attr("stroke-width", 0);
      const my: Rect = namePlates[num] as Rect;
      my.attr("stroke-width", 2).attr("stroke", "#fff");
      const scenario: Scenario = this.mapData.scenarios[num];
      const categories: string[] = [];
      const propMap: ItemName = {
        itemPaperSizes: "itemPaperSizeId",
        itemPrinters: "itemPrinterId",
        itemCoaters: "groupCoaters",
        itemDieCuts: "groupDieCuts",
        itemGlues: "groupGlues",
        itemOptions: "groupOptions",
        itemOthers: "groupOthers",
        itemCustoms: "groupCustoms",
        itemMargins: "groupMargins"
      };
      for (const category of this.scenarioKeys) {
        categories.push(category.className);
      }

      const arrows: List<Element> = this.draw.find(".arrow");
      const arrowClass = "arrow_" + num;
      let opacity: number;
      for (const arrow of arrows) {
        opacity = !arrow.hasClass(arrowClass) ? 0.15 : 1;
        arrow.attr({
          opacity: opacity
        });
      }

      let category: string;
      for (category of categories) {
        const list: any = this.draw.find("." + category);
        list.attr({
          opacity: 0.75
        });
        const propName: string = propMap[category];
        const val: number | string | string[] = scenario[propName];
        switch (category) {
          case "itemPaperSizes":
          case "itemPrinters":
            this.draw.find("#" + category + "_" + val)[0].attr({
              opacity: 0
            });
            break;
          default:
            for (const item of val as string[]) {
              this.draw.find("#" + category + "_" + item)[0].attr({
                opacity: 0
              });
            }
            break;
        }
      }
    };
  }

  deFocus(): void {
    const list: any = this.draw.find(".itemBlock");
    list.attr({
      opacity: 0
    });
    const arrows: any = this.draw.find(".arrow");
    arrows.attr({
      opacity: 1
    });
    const namePlates: any = this.scenarioNames;
    namePlates.find(".namePlate").attr("stroke-width", 0);
  }

  beforeDestroy(): void {
    this.draw.forget();
    window.removeEventListener("scroll", this.moveScenarioNames);
  }

  moveScenarioNames(): void {
    const multiplyer: number = 1 / this.viewBoxVal;
    const htmlEle: HTMLHtmlElement = document.getElementsByTagName("html")[0];
    const scrollLeft = htmlEle.scrollLeft * multiplyer + 20;
    this.scenarioNames.move(scrollLeft, this.boxTop);
  }

  setViewBox(e: Event): void {
    const my: HTMLInputElement = e.target as HTMLInputElement;
    const val = parseFloat(my.value);
    const multiplyer: number = 1 / val;
    this.viewBoxVal = val;
    this.draw.viewbox(0, 0, this.fieldW * multiplyer, this.fieldH * multiplyer);
    this.moveScenarioNames();
  }
}
